export enum KeyboardKey {
  Enter = 'Enter',
  Up = 'Up',
  Down = 'Down',
  Left = 'Left',
  Right = 'Right',
  Escape = 'Escape'
}
